// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filter-button {
  display: flex;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
  background: #FFFFFF;
  padding: 6px 12px;
  color: #999999;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  transition: all ease .3s;
}

.filter-button svg {
  stroke: #999999;
}

.filter-button:hover {
  background-color: #999999;
  color: #FFFFFF;
}

.filter-button:hover svg {
  stroke: #FFFFFF;
}
`, "",{"version":3,"sources":["webpack://./src/components/button/FilterButton.scss","webpack://./src/components/button/FilterButton.css"],"names":[],"mappings":"AAAA;EAGE,aAAQ;EAGD,mBAAU;EACjB,QAAO;EACP,kBAAe;EACf,mBAAkB;EAClB,iBAAgB;EAChB,cAAa;EACb,eAAY;EAcb,kBAAA;ECZC,gBAAgB;EDdlB,mBAcM;EAEH,wBAAA;ACEH;;AAEA;EDAI,eAAc;ACElB;;ADtBA;EAuBM,yBAAe;EAChB,cAAA;ACGL;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".filter-button {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  border-radius: 8px;\n  background: #FFFFFF;\n  padding: 6px 12px;\n  color: #999999;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  transition: all ease .3s;\n\n  svg {\n    stroke: #999999;\n  }\n\n  &:hover {\n    background-color: #999999;\n    color: #FFFFFF;\n\n    svg {\n      stroke: #FFFFFF;\n    }\n  }\n}",".filter-button {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  gap: 8px;\n  border-radius: 8px;\n  background: #FFFFFF;\n  padding: 6px 12px;\n  color: #999999;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  -webkit-transition: all ease .3s;\n  transition: all ease .3s;\n}\n\n.filter-button svg {\n  stroke: #999999;\n}\n\n.filter-button:hover {\n  background-color: #999999;\n  color: #FFFFFF;\n}\n\n.filter-button:hover svg {\n  stroke: #FFFFFF;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
